/**
 * Task #10: Liste controlate pentru specie/rasa
 * Date statice pentru specii si rase comune
 */

export interface Species {
  value: string;
  label: string;
  icon: string;
}

export interface Breed {
  species: string;
  value: string;
  label: string;
  common?: boolean;
}

export const SPECIES: Species[] = [
  { value: 'dog', label: 'Câine', icon: '🐕' },
  { value: 'cat', label: 'Pisică', icon: '🐱' },
  { value: 'bird', label: 'Pasăre', icon: '🐦' },
  { value: 'rabbit', label: 'Iepure', icon: '🐰' },
  { value: 'horse', label: 'Cal', icon: '🐴' },
  { value: 'other', label: 'Altele', icon: '🐾' },
];

export const DOG_BREEDS: Breed[] = [
  { species: 'dog', value: 'golden_retriever', label: 'Golden Retriever', common: true },
  { species: 'dog', value: 'labrador', label: 'Labrador Retriever', common: true },
  { species: 'dog', value: 'german_shepherd', label: 'Ciobanesc German', common: true },
  { species: 'dog', value: 'bulldog', label: 'Bulldog', common: true },
  { species: 'dog', value: 'beagle', label: 'Beagle', common: true },
  { species: 'dog', value: 'poodle', label: 'Pudel', common: true },
  { species: 'dog', value: 'rottweiler', label: 'Rottweiler', common: true },
  { species: 'dog', value: 'yorkshire', label: 'Yorkshire Terrier', common: true },
  { species: 'dog', value: 'boxer', label: 'Boxer', common: true },
  { species: 'dog', value: 'dachshund', label: 'Teckel', common: true },
  { species: 'dog', value: 'siberian_husky', label: 'Husky Siberian', common: true },
  { species: 'dog', value: 'pug', label: 'Pug', common: true },
  { species: 'dog', value: 'chihuahua', label: 'Chihuahua', common: true },
  { species: 'dog', value: 'pomeranian', label: 'Pomeranian', common: true },
  { species: 'dog', value: 'shih_tzu', label: 'Shih Tzu', common: true },
  { species: 'dog', value: 'doberman', label: 'Doberman', common: true },
  { species: 'dog', value: 'maltese', label: 'Maltez', common: true },
  { species: 'dog', value: 'corgi', label: 'Corgi', common: true },
  { species: 'dog', value: 'border_collie', label: 'Border Collie', common: true },
  { species: 'dog', value: 'cocker_spaniel', label: 'Cocker Spaniel', common: true },
  { species: 'dog', value: 'mestec', label: 'Metis/Corcitura', common: true },
  { species: 'dog', value: 'other', label: 'Alta rasa', common: false },
];

export const CAT_BREEDS: Breed[] = [
  { species: 'cat', value: 'persian', label: 'Persana', common: true },
  { species: 'cat', value: 'maine_coon', label: 'Maine Coon', common: true },
  { species: 'cat', value: 'siamese', label: 'Siameză', common: true },
  { species: 'cat', value: 'british_shorthair', label: 'British Shorthair', common: true },
  { species: 'cat', value: 'bengal', label: 'Bengal', common: true },
  { species: 'cat', value: 'ragdoll', label: 'Ragdoll', common: true },
  { species: 'cat', value: 'sphynx', label: 'Sphynx', common: true },
  { species: 'cat', value: 'scottish_fold', label: 'Scottish Fold', common: true },
  { species: 'cat', value: 'abyssinian', label: 'Abisiniană', common: true },
  { species: 'cat', value: 'russian_blue', label: 'Rusă Albastră', common: true },
  { species: 'cat', value: 'norwegian_forest', label: 'Pisică de Pădure Norvegiană', common: true },
  { species: 'cat', value: 'birman', label: 'Birman', common: true },
  { species: 'cat', value: 'exotic_shorthair', label: 'Exotic Shorthair', common: true },
  { species: 'cat', value: 'european_shorthair', label: 'Europeana', common: true },
  { species: 'cat', value: 'mixed', label: 'Metis/Comună', common: true },
  { species: 'cat', value: 'other', label: 'Altă rasă', common: false },
];

export const BIRD_BREEDS: Breed[] = [
  { species: 'bird', value: 'canary', label: 'Canar', common: true },
  { species: 'bird', value: 'budgie', label: 'Papagal Mic/Perusa', common: true },
  { species: 'bird', value: 'cockatiel', label: 'Cockatiel/Nimfa', common: true },
  { species: 'bird', value: 'lovebird', label: 'Agapornis', common: true },
  { species: 'bird', value: 'parrot', label: 'Papagal (Mare)', common: true },
  { species: 'bird', value: 'macaw', label: 'Ara', common: false },
  { species: 'bird', value: 'cockatoo', label: 'Cacadu', common: false },
  { species: 'bird', value: 'finch', label: 'Pinson', common: true },
  { species: 'bird', value: 'dove', label: 'Porumbel', common: true },
  { species: 'bird', value: 'chicken', label: 'Gaina', common: true },
  { species: 'bird', value: 'other', label: 'Alta pasare', common: false },
];

export const RABBIT_BREEDS: Breed[] = [
  { species: 'rabbit', value: 'holland_lop', label: 'Holland Lop', common: true },
  { species: 'rabbit', value: 'netherland_dwarf', label: 'Pitic Olandez', common: true },
  { species: 'rabbit', value: 'mini_rex', label: 'Mini Rex', common: true },
  { species: 'rabbit', value: 'lionhead', label: 'Cap de Leu', common: true },
  { species: 'rabbit', value: 'flemish_giant', label: 'Gigant Flamand', common: true },
  { species: 'rabbit', value: 'angora', label: 'Angora', common: true },
  { species: 'rabbit', value: 'lop_eared', label: 'Cu Urechi Cazute', common: true },
  { species: 'rabbit', value: 'rex', label: 'Rex', common: true },
  { species: 'rabbit', value: 'mixed', label: 'Metis', common: true },
  { species: 'rabbit', value: 'guinea_pig', label: 'Cobai', common: true },
  { species: 'rabbit', value: 'hamster', label: 'Hamster', common: true },
  { species: 'rabbit', value: 'chinchilla', label: 'Chinchilla', common: true },
  { species: 'rabbit', value: 'other', label: 'Alta rozatoare', common: false },
];

export const HORSE_BREEDS: Breed[] = [
  { species: 'horse', value: 'arabian', label: 'Arab', common: true },
  { species: 'horse', value: 'thoroughbred', label: 'Pursange', common: true },
  { species: 'horse', value: 'quarter_horse', label: 'Quarter Horse', common: true },
  { species: 'horse', value: 'warmblood', label: 'Warmblood', common: true },
  { species: 'horse', value: 'andalusian', label: 'Andaluz', common: true },
  { species: 'horse', value: 'friesian', label: 'Friesian', common: true },
  { species: 'horse', value: 'mustang', label: 'Mustang', common: true },
  { species: 'horse', value: 'shetland_pony', label: 'Poney Shetland', common: true },
  { species: 'horse', value: 'mixed', label: 'Metis', common: true },
  { species: 'horse', value: 'other', label: 'Alta rasa', common: false },
];

export const OTHER_SPECIES: Breed[] = [
  { species: 'other', value: 'turtle', label: 'Broască Țestoasă', common: true },
  { species: 'other', value: 'ferret', label: 'Dihor', common: true },
  { species: 'other', value: 'iguana', label: 'Iguana', common: true },
  { species: 'other', value: 'snake', label: 'Șarpe', common: true },
  { species: 'other', value: 'fish', label: 'Pește', common: true },
  { species: 'other', value: 'other', label: 'Altele', common: false },
];

/**
 * Obtine rasele pentru o anumita specie
 */
export const getBreedsBySpecies = (species: string): Breed[] => {
  switch (species) {
    case 'dog':
      return DOG_BREEDS;
    case 'cat':
      return CAT_BREEDS;
    case 'bird':
      return BIRD_BREEDS;
    case 'rabbit':
      return RABBIT_BREEDS;
    case 'horse':
      return HORSE_BREEDS;
    case 'other':
      return OTHER_SPECIES;
    default:
      return [];
  }
};

/**
 * Obtine rasele comune pentru o specie
 */
export const getCommonBreeds = (species: string): Breed[] => {
  return getBreedsBySpecies(species).filter(breed => breed.common);
};

/**
 * Cauta rase dupa text
 */
export const searchBreeds = (species: string, query: string): Breed[] => {
  const breeds = getBreedsBySpecies(species);
  const lowerQuery = query.toLowerCase();
  
  return breeds.filter(breed =>
    breed.label.toLowerCase().includes(lowerQuery) ||
    breed.value.toLowerCase().includes(lowerQuery)
  );
};

